<div class="container_dialog">
  <div class="header_popup header_popup_center">
    <div class="title_popup title_popup_center">
        <span>{{"companies.adress"|translate}}</span>
    </div>
    <button (click)="closed()">
        <mat-icon style="color: black;">close</mat-icon>
    </button>
</div>
  <div class="display_form" [formGroup]="form">
    <div class="step_title">
      <span class="sub_title">
        {{"companies.shipping_address"|translate}}
      </span>
    </div>
    <div class="content">
      <div class="inline_block">
        <div class="field">
          <label for="">{{"common.location_name"|translate }}</label>
          <input type="text" formControlName="name" [placeholder]="'common.location_name'|translate">
          <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">
           {{"common.required_field"|translate}}
          </span>
        </div>
      </div>
      <div class="inline_block">
        <div class="field">
          <label for="">{{"companies.loc_adress"|translate}}</label>
          <input type="text" formControlName="apartment" [placeholder]="'companies.apartment'|translate" id="apartment">
          <span class="error_ms" *ngIf="form.get('apartment')?.touched && form.get('apartment')?.errors">
            {{"common.required_field"|translate}}
          </span>
        </div>
      </div>
      <div class="step_title">
        <span class="sub_title">
         {{"companies.billing_address"|translate}}
        </span>
      </div>
      <div class="inline_block slide_block">
        <mat-slide-toggle formControlName="is_bill_same" (change)="toggleBillingAddress()">
        </mat-slide-toggle>
        <span>{{"companies.billing_shipping"|translate}}</span>
      </div>
      <div class="inline_block">
        <div class="field">
          <label for="">{{"companies.loc_adress"|translate}}</label>
          <input type="text" formControlName="billing_apartment" [placeholder]="'companies.adress'|translate " [attr.disabled]="this.form.get('is_bill_same')?.value === true ? 'true' : null"  id="billing_apartment">
          <span class="error_ms" *ngIf="form.get('billing_apartment')?.touched && form.get('billing_apartment')?.errors">
            {{"common.required_field"|translate}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
      <span>{{"common.back"|translate | uppercase}}</span>
      <img src="../../../../../assets/icones/arrow_back.svg" alt="">
    </button>
    <button class="save_btn_pop_up blue_btn " (click)="save()">
        <span> {{"common.save"|translate | uppercase}}</span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
</div>
</div>
